<template>
  <div class="moment">
    <div class="header-tool">
      <div class="header-tool-info">
        <Breadcrumb>
          <BreadcrumbItem to="/exhibition/index">推广</BreadcrumbItem>
          <BreadcrumbItem>动态</BreadcrumbItem>
        </Breadcrumb>
        <div class="header-tool-title">{{exhibition.name}}</div>
      </div>
      <div class="header-tool-box">
        <div class="htb-item" @click="publicInfo">
          <span class="htb-add">+</span>
          <span>发布动态</span>
        </div>
      </div>
    </div>

    <div class="moment-content" v-if="momentList && momentList.length">
      <div
        class="moment-content-1"
        v-for="(item,index) of momentList"
        :key="'moment-' + Math.random() + index"
      >
        <Row
          class="moment-list"
          v-if="item.photo && item.photo.length"
          :gutter="16"
          type="flex"
          align="middle"
        >
          <Col span="4">
            <div class="moment-list-cover">
              <img :src="item.photo[0]" />
            </div>
          </Col>
          <Col span="14" class="moment-title" @click.native="showCode(item)">
            <p>{{item.information}}</p>
            <div class="moment-info">
              <div>
                <i class="icon iconfont icon-chakan" style="font-size:18px;"></i>
                {{item.viewCount}}
              </div>
              <div>
                <i class="icon iconfont icon-fenxiang2" style="font-size:18px;"></i>
                {{item.shareCount}}
              </div>
              <div>
                <i class="icon iconfont icon-shoucang1" style="font-size:18px;"></i>
                {{item.followCount}}
              </div>
            </div>
          </Col>
          <Col span="4">{{item.inTime | dateFormat}}</Col>
          <Col span="2">
            <Poptip confirm title="确认删除该动态吗?" @on-ok="delMoment(item)">
              <p class="moment-del">删除</p>
            </Poptip>
          </Col>
        </Row>
        <Row class="moment-list" v-else :gutter="16" type="flex" align="middle">
          <Col span="4">
            <div class="moment-list-cover">
              <img src="@/assets/img/empty.png" />
            </div>
          </Col>
          <Col span="14" class="moment-title" @click.native="showCode(item)">
            <p>{{item.information}}</p>
            <div class="moment-info">
              <div>
                <i class="icon iconfont icon-chakan" style="font-size:18px;"></i>
                {{item.viewCount}}
              </div>
              <div>
                <i class="icon iconfont icon-fenxiang2" style="font-size:18px;"></i>
                {{item.shareCount}}
              </div>
              <div>
                <i class="icon iconfont icon-shoucang1" style="font-size:18px;"></i>
                {{item.followCount}}
              </div>
            </div>
          </Col>
          <Col span="4">{{item.inTime | dateFormat}}</Col>
          <Col span="2">
            <Poptip confirm title="确认删除该动态吗?" @on-ok="delMoment(item)">
              <p class="moment-del">删除</p>
            </Poptip>
          </Col>
        </Row>
      </div>
    </div>
    <div class="u-empty" v-else>暂无数据</div>

    <div class="my-page" v-if="totalCount > pageSize">
      <Page
        show-total
        show-elevator
        :page-size="pageSize"
        :current="pageIndex"
        :total="totalCount"
        @on-change="changePage"
        @on-page-size-change="changePageSize"
      />
    </div>

    <!-- 发布动态 -->
    <iModal
      v-model="momentFlag"
      title="发布动态"
      width="400px"
      :styles="{top:'300px'}"
      :mask-closable="false"
    >
      <div>
        <Select v-model="releaseType" style="width:250px;margin-bottom:25px;">
          <Option @click.native="selectReType(item)" v-for="item in releaseTypeList" :value="item.name" :key="item.name + Math.random()">{{ item.name }}</Option>
        </Select>
        <Input
          v-model="momentText"
          type="textarea"
          :rows="4"
          :maxlength="500"
          placeholder="你此刻的想法"
          :autosize="{minRows: 4, maxRows: 4}"
        />
        <p style="text-align:right;color:#bfbfbf;margin-top:10px;">{{momentText.length}} / 500 字</p>
        <div
          class="my-upload-list"
          v-for="(item, index) in uploadList"
          :key="'upload' + Math.random() + index"
          style="width: 80px;height: 80px;line-height:80px"
        >
          <template v-if="item.status === 'finished'">
            <img :src="item.url" />
            <div class="my-upload-list-cover">
              <Icon type="ios-eye-outline" @click.native="handleView(item.url)"></Icon>
              <Icon type="ios-trash-outline" @click.native.stop.prevent="handleRemoveByArr(item)"></Icon>
            </div>
          </template>
          <template v-else>
            <Spin v-if="item.showProgress" style="width: 80px;height: 80px;">
              <Icon type="ios-loading" size="20" class="demo-spin-icon-load"></Icon>
            </Spin>
          </template>
        </div>
        <Upload
          ref="upload"
          :show-upload-list="false"
          :default-file-list="defaultList"
          :on-success="handleSuccess"
          :format="['jpg','jpeg','png']"
          :max-size="2048"
          :headers="formHeaders"
          :on-format-error="handleFormatError"
          :on-exceeded-size="handleMaxSize"
          :before-upload="handleBeforeUpload"
          type="drag"
          :action="uploadUrl"
          multiple
          style="display: inline-block;width:80px;"
          v-show="uploadList && uploadList.length < 5"
        >
          <div style="width: 80px;height:80px;padding-top: 10px;">
            <div style="font-size:20px;color:#888888;">
              +
              <p style="font-size:12px;">上传图片</p>
            </div>
          </div>
          <!-- 蒙版 -->
          <div
            style="position:absolute;opacity:0;width:80px;height:80px;left:0;top:0;"
            @click.stop="selectType"
          ></div>
        </Upload>
        <!-- <p class="upload-p">(图片要求：2M以下的jpg或png，建议尺寸500*700px)</p> -->
      </div>
      <div slot="footer">
        <Button :loading="loading" type="primary" @click="submit()">确定</Button>
        <Button @click="momentFlag = false">取消</Button>
      </div>
    </iModal>

    <!-- 查看小程序码 -->
    <iModal title="扫码查看" footer-hide width="400px" :styles="{top:'300px'}" v-model="codeFlag">
      <div style="padding-top:20px;display:flex;flex-direction:column;align-items:center;height:180px;justify-content:space-around;">
        <img :src="weAppCodeUrl"  style="width:100px;height:100px;">
        <p>微信扫一扫，查看动态详情</p>
      </div>
    </iModal>

    <iModal title="图片查看" cancel-text v-model="visible" :z-index="10002">
      <div style="text-align: center;">
        <img :src="imgName" v-if="visible" style="max-width: 100%" />
      </div>
    </iModal>

    <!-- 新建展会确认框 -->
    <iModal
      v-model="confirmModal"
      title="确认"
      width="400px"
      @on-ok="confirmOk"
      @on-cancel="confirmCancel"
    >
      <p>未绑定任何展会时，是否前去绑定展会 ?</p>
    </iModal>

    <imgUpload
      @upload:local="uploadLocal"
      @upload:material="uploadMaterial"
      fileType="img"
      :maxCount="5"
      v-model="uploadChooseShowed"
    />
    <Contact />


    
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Contact from "@components/Contact/Contact";
import imgUpload from "@components/imgUpload/imgUpload.vue";
export default {
  name: "exhibition-moment",
  data() {
    return {
      releaseType: "",
      releaseTypeId: "",
      releaseTypeList: [],
      momentList: null,
      momentFlag: false,
      momentText: "",
      uploadList: [],
      defaultList: [],
      uploadChooseShowed: false,
      imgName: "",
      visible: false,
      pageSize: 10,
      pageIndex: 1,
      totalCount: 0,
      loading: false,
      codeFlag: false,
      confirmModal: false,
      weAppCodeUrl: "", // 小程序码
    };
  },
  computed: {
    ...mapGetters({
      company: "loginModule/getCompany", 
      uploadUrl: "getUploadUrl",
      formHeaders: "getFormHeaders",
      joinEx: "companyModule/getJoinEx", 
      exhibition: "loginModule/getExhibition"
    })
  },
  components: {
    Contact,
    imgUpload 
  },
  methods: {
    ...mapActions({
      getRelease: "momentModule/getRelease",
      addRelease: "momentModule/addRelease",
      delRelease: "momentModule/delRelease",
      getWeAppSmallCode: "momentModule/getWeAppSmallCode",
      getReleaseType: "momentModule/getReleaseType"
    }),
    handleSuccess(res, file) {
      if (res && res.list.length) {
        file.url = res.list[0];
        this.uploadList = this.$refs.upload.fileList;
      }
    },
    handleFormatError(file) {
      this.$Message.warning(`文件格式是不正确的, 请上传jpg或者png格式的图片`);
    },
    handleMaxSize(file) {
      this.$Message.warning(`文件大小超过限制, 请上传小于2M的图片`);
    },
    handleBeforeUpload() {
      const limitNum = 5;
      const check = this.uploadList.length < limitNum;
      if (!check) {
        this.$Message.warning(`最多上传${limitNum}张图片`);
      }
      return check;
    },
    selectType() {
      this.uploadChooseShowed = true;
    },
    uploadLocal() {
      this.$refs.upload.handleClick();
    },
    uploadMaterial(e) {
      for (let item of e) {
        if (this.uploadList.length >= 5) {
          this.$Message.warning(`最多上传5张图片`);
          return;
        } else {
          this.uploadList.push({
            status: "finished",
            url: item
          });
          this.uploadChooseShowed = false;
        }
      }
    },
    handleView(name) {
      this.imgName = name;
      this.visible = true;
    },
    handleRemoveByArr(file) {
      const fileList = this.uploadList;
      this.uploadList.splice(fileList.indexOf(file), 1);
    },
    async init() {
      if (this.joinEx) {
        let data = await this.getReleaseType(this.joinEx.exhibitionId);
        if (data && data.length > 0) {
          this.releaseTypeList = data;
        }
      }
      let result = await this.getRelease({
        CompId: this.company.id,
        PageSize: this.pageSize,
        PageIndex: this.pageIndex
      });
      if (result && result.items) {
        result.items.map(c => {
          if (c.photo.indexOf("[") !== -1) {
            c.photo = JSON.parse(c.photo);
          } else {
            c.photo = [];
          }
        });
      }
      this.momentList = result.items;
      if (this.momentList) {
        this.pageSize = result.pageSize;
        this.pageIndex = result.pageIndex;
        this.totalCount = result.totalCount;
      }
    },
    changePage(e) {
      this.pageIndex = e;
      this.init();
    },
    changePageSize(e) {
      this.pageSize = e;
      this.init();
    },
    selectReType(value) {
      this.releaseType = value.name;
      this.releaseTypeId = value.id;
    },
    async submit() {
      if (this.momentText === "") {
        this.$Message.error("请输入内容");
        return;
      }
      if (!this.releaseTypeId) {
        this.$Message.error("请选择动态类型");
        return;
      }
      let photo = this.transfromImgList(this.uploadList);
      let form = {
        AgentId: this.joinEx.agentId,
        ExhibitionId: this.joinEx.exhibitionId,
        TypeId: this.releaseTypeId,
        FromType: 0,
        FromId: this.company.id,
        Photo: photo,
        Information: this.momentText
      };
      console.log(form)
      this.loading = true;
      let result = await this.addRelease(form);
      this.loading = false;
      if (result.successed) {
        this.$Message.success("发布成功");
        this.close();
        this.init();
      } else {
        this.$Message.error("发布失败，请重新尝试");
      }
    },
    transfromImgList(arr) {
      let arr2 = [];
      arr.forEach(c => {
        arr2.push(c.url);
      });
      return arr2;
    },
    close() {
      this.momentFlag = false;
      this.momentText = "";
      this.uploadList = [];
      this.$refs.upload.fileList = [];
    },
    async showCode(value) {
      this.codeFlag = true;
      let req = {
        id: value.id,
        releaseId: value.id
      };
      let result = await this.getWeAppSmallCode(req);
      if (result && result.path) {
        this.weAppCodeUrl = result.path;
      } else {
        this.$Message.error("获取小程序码失败，请重新尝试");
      }
    },
    async delMoment(data) {
      let result = await this.delRelease(data.id);
      if (result.successed) {
        this.$Message.success("删除成功");
        this.init();
      } else {
        this.$Message.error("删除失败，请重新尝试");
      }
    },
    publicInfo() { 
      if (this.joinEx) {
        this.momentFlag = true;
      } else {
        this.confirmModal = true;
      }
    },
    confirmOk() {
      this.$router.push("/exhibition/template/choice");
    },
    confirmCancel() {
      this.confirmModal = false;
    }
  },
  mounted() {
    this.init();
    if (this.$refs.upload) {
      this.uploadList = this.$refs.upload.fileList;
    }
  }
};
</script>

<style lang="scss" scoped>
.moment-content {
  min-width: 1000px;
  background-color: #fff;
  margin: 30px;
  &-1 {
    border-bottom: 1px solid #ddd;
    border-top: 1px solid transparent;
    border-right: 1px solid transparent;
    border-left: 1px solid transparent;
    &:hover {
      border-color: blue;
    }
    .moment-title {
      &:hover {
        cursor: pointer;
      }
    }
  }
  .moment-list {
    padding: 20px;
    &-cover {
      padding-bottom: 66.66667%;
      position: relative;
      img {
        max-width: 100%;
        max-height: 100%;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
      }
    }
    .moment-info {
      width: 30%;
      display: flex;
      margin-top: 10px;
      justify-content: space-between;
      div {
        display: flex;
        align-items: center;
      }
    }
    .moment-del {
      color: #ff0000;
      cursor: pointer;
    }
  }
}
.my-page {
  margin-left: 50px;
}
</style>